import type { ReactNode } from 'react';
import { cn } from '../../../utils/cn';
import styles from './ButtonGroup.module.css';

export interface ButtonGroupProps {
  children: ReactNode;
  className?: string;
  ariaLabel?: string;
}

/**
 * Wraps 2-4 Button children with a shared border (no gap) — used in
 * the diary toolbar and table row actions.
 */
export function ButtonGroup({ children, className, ariaLabel }: ButtonGroupProps) {
  return (
    <div role="group" aria-label={ariaLabel} className={cn(styles.group, className)}>
      {children}
    </div>
  );
}
